export default {
  // header
  'develop': 'Develop',
  'representative': 'Representative',
  'resources': 'Resources',
  'maroscan': 'Maro scan',
  'menu': 'menu',
  'close': 'close',

  // footer
  'footer_links': 'Other Links',
  'footer_resources': 'Resources',
  'footer_media': 'Social media',
  'about_contant4_time1': 'July, 2020',
  'about_contant4_time1_txt1': 'Maro Rebranding',
  'about_contant4_time2': 'June, 2020',
  'about_contant4_time2_txt1': 'WorkBox Launched',
  'about_contant4_time3': 'March, 2020',
  'about_contant4_time3_txt1': 'Over  10,000,000 blocks produced',
  'about_contant4_time4': 'December, 2019',
  'about_contant4_time4_txt1': 'Stablecoin Launched',
  'about_contant4_time5': 'September, 2019',
  'about_contant4_time5_txt1': 'Tigris Protocol Launched',
  'about_contant4_time6': 'August, 2019',
  'about_contant4_time6_txt1': 'Acorn Protocol Beta Launched',
  'about_contant4_time7': 'July, 2019',
  'about_contant4_time7_txt1': 'Slave Network Launched',
  'about_contant4_time8': 'April, 2019',
  'about_contant4_time8_txt1': 'Maro Connect Launched',
  'about_contant4_time9': 'March, 2019',
  'about_contant4_time9_txt1': 'Mainnet Launched',
  'about_contant4_time10': 'August, 2018',
  'about_contant4_time10_txt1': 'Maro Scan Launched',
  'about_contant4_time11': 'January, 2018',
  'about_contant4_time11_txt1': 'Maro Foundation Founded',

  // home
  'content1_h1': 'Ecosystem for open network collaboration',
  'content1_p': 'Acorn Protocol aims to build an ecosystem for open network collaboration. Acorn Protocol facilitates creation, curation, evaluation, and exchange of data, empowering people to cherish the value of data.',
  'content1_learn': 'Learn More',

  'content2_h1': 'Now everybody creates value',
  'content2_p1': 'With Acorn Protocol, anyone can create value and get rewarded based on their contribution in real-time. Acorn Protocol builds a transparent, sustainable network economy protocol',
  'content2_p2': 'Acorn protocol provides',
  'content2_p3': '- An open and collaborative network for value creation and exchange',
  'content2_p4': '- A high capacity network designed for mass collaboration',

  'content3_h3': 'A new form of value creation',
  'content3_text1': 'Acorn Protocol provides a set of data processing and incentivizing system. The value of data is fairly and transparently recognized. So, the data provider is fairly compensated and the data consumer can be ensured reliable data. ',
  'content3_h5_1': 'Acorn Token (ACN)',
  'content3_text2': 'When the value of data is recognized, the data providers will receive Acorn tokens from the protocol or data consumer. Acorn tokens monetize data value and make the value flow in a vibrant way.',
  'content3_h5_2': 'Acorn Box',
  'content3_text3': 'An easy-to-use mobile wallet app built for anyone who would like to acquire, manage, and utilize ACN',
  'content3_download': 'Download',

  'content4_h3': 'For developers',
  'content4_text1': 'Empower your community with Acorn Protocol. Acorn Protocol connects data providers and data consumers to create a win-win platform for value transactions. Developers can deploy their service with Acorn Protocol seamlessly with the Acorn SDK',

  'content5_h3': 'DAPPs building the Acorn Ecosystem',
  'content5_text1': 'Acorn Rewards Engine attracts proactive users into the ecosystem, consequently building a healthy and vitalized Acorn Ecosystem primed for exponential user growth.',
  'content5_workbox': 'A platform where you can work whenever and wherever',
  'content5_tata': 'Personal life sharing platform with over 13m young Chinese users, aka "Instagram of China"',
  'content5_alive': 'Video editing/sharing platform with over 10m downloads globally',
  'content5_cobak': 'Korea’s #1 mobile community for cryptocurrency enthusiasts',
  'content5_socdoc': 'Korea’s #1 anonymous mobile community for women',
  'content5_piki': 'Korea’s top mobile content sharing platform with over 19m downloads',
  'content5_womanstalk': 'Korea’s largest video commerce platform with 1.2M registered users',
  'content5_infonesia': 'Mobile Q&A Platform based in Indonesia',
  'content5_git': 'A token-incentivized collaboration tool for developers and open source projects',
  'content5_apply': 'Apply Now',

  'content6_h3': 'On Maro Blockchain',
  'content6_text1': 'Maro Blockchain, a high-functioning blockchain infrastructure with a sustainable token economy ecosystem, significantly boosts the value of Acorn Protocol. By connecting data providers and data consumers, Acorn Protocol on Maro ultimately transforms traditional industries into a data economy.',
  'content6_learn': 'Learn More'
}



// WEBPACK FOOTER //
// ./src/i18n/en.js